import type { DirectiveNode, VariableDefinitionNode } from 'graphql';

import { getNamedTypeNode } from './getNamedTypeNode';
import type { DirectiveMap } from './getDirectives';
import { getDirectives } from './getDirectives';

export type VariableDefinition = {
  name: string;
  type: string;
  isRequired: boolean;
  isArray: boolean;
  directives: DirectiveMap;
  directiveNodes?: readonly DirectiveNode[];
};

export const getVariableFromDefinitionNode = (
  variableDefinition: VariableDefinitionNode,
): VariableDefinition => ({
  name: variableDefinition.variable.name.value,
  type: getNamedTypeNode(variableDefinition.type).name.value,
  isRequired: variableDefinition.type.kind === 'NonNullType',
  isArray: variableDefinition.type.kind === 'ListType',
  directives: getDirectives(variableDefinition.directives),
  directiveNodes: variableDefinition.directives,
});
